import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  CircularProgress,
  Divider,
} from "@mui/material";
import { IoMdClose } from "react-icons/io";
import { CommonAPImain } from "../../../../Utils/API/CommonAPImain/CommonAPImain";
import Header from "../../Home/Header/Header";
import CustomTextField from "../../../TextFiled/Index";
import "./OrderReport.scss";

const OrderReport = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    setIsLoading(true);
    CommonAPImain("Report_Order")
      .then((response) => {
        if (response?.Data?.DT) {
          const formattedData = response.Data.DT.map((item, index) => ({
            ...item,
            id: index + 1,
            TotalGrosswt: item.T_Gwt || 0,
            TotalNetwt: item.T_Nwt || 0,
          }));
          setOrderData(formattedData);
          setFilteredData(formattedData);
        } else {
          console.error("Invalid response structure");
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to fetch order data.");
        setIsLoading(false);
      });
  }, []);

  const handleSearch = (e) => {
    const val = e.target.value.toLowerCase();
    setSearchQuery(val);
    const filtered = orderData.filter((item) =>
      item.CustomerCode.toLowerCase().includes(val)
    );
    setFilteredData(filtered);
  };

  const clearSearch = () => {
    setSearchQuery("");
    setFilteredData(orderData);
  };

  return (
    <div className="orderreport_main">
      <Header otherPage={true} title="Order Report" />
      <div className="orderreport_container">
        <Box mb={1}>
          <CustomTextField
            value={searchQuery}
            onChange={handleSearch}
            placeholder="Search by Customer Code"
            className="searchBox_input"
            InputProps={{
              endAdornment: searchQuery && (
                <IconButton onClick={clearSearch}>
                  <IoMdClose />
                </IconButton>
              ),
            }}
          />
        </Box>

        {isLoading ? (
          <Box className="loadingBox">
            <CircularProgress />
          </Box>
        ) : filteredData.length === 0 ? (
          <Typography className="noDataText">No Data Found</Typography>
        ) : (
          <div className="report_list">
            {filteredData.map((item) => (
              <Box key={item.id} className="report_block">
                <Typography className="customer_code">
                  {item.CustomerCode}
                </Typography>

                <Typography className="amount">
                  ₹ {item.T_Amt.toLocaleString("en-IN")}
                </Typography>

                <Box className="row">
                  <span className="label">Gross Wt:</span>
                  <span className="value">{item.TotalGrosswt.toFixed(3)} g</span>
                </Box>

                <Box className="row">
                  <span className="label">Net Wt:</span>
                  <span className="value">{item.TotalNetwt.toFixed(3)} g</span>
                </Box>

                <Box className="row">
                  <span className="label">Quote / ETA / REM:</span>
                  <span className="value">
                    {item.Qut_Job} / {item.ETA_Job} / {item.REM_Job}
                  </span>
                </Box>

                <Divider className="divider" />
              </Box>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderReport;